import Container from '@/components/Container'
import LandingActionButtons from '@/components/LandingActionButtons'
import Typography from '@/components/Typography'

import { cn } from '@/utils'

const ContactUsSection = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(`relative flex items-center bg-slate-800 py-20`, className)}
    >
      <Container className="flex flex-col items-center justify-center gap-8">
        <Typography
          variant="h4"
          className="contact-us-ready-text text-center"
          margin="none"
        >
          Ready to get started?
        </Typography>

        <LandingActionButtons className="mt-8" position="footer" />
      </Container>
    </div>
  )
}

export default ContactUsSection
